import { api } from 'app/config/apiConfig';
import { Discount } from '../model/types';

export const createDiscountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createDiscount: builder.mutation<Discount, Discount>({
      query: (data) => ({
        url: '/discounts',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Discounts'],
    }),
  }),
});

export const { useCreateDiscountMutation } = createDiscountApi;
